<template>
  <div class="container-fluid" v-if="isLoaded && sharedCaptch.featureEnabled">
    <ps-captcha-recaptcha
      ref="recaptcha"
      v-if="isRecapcha"
      @solutionChanged="onSolution"
    ></ps-captcha-recaptcha>
    <ps-captcha-friendly
      ref="friendlyCap"
      v-if="isFrienly"
      @solutionChanged="onSolution"
    ></ps-captcha-friendly>
  </div>
</template>

<script>
import Vue from "vue";

import { PSCaptchaRoutingService } from "@/Captcha/services/PSCaptchaRoutingService";
import { SharedCaptchaSettings } from "@/Captcha/models/responses/SharedCaptchaSettings.ts";
import { CaptchaProviderSettings } from "@/Captcha/models/responses/CaptchaProviderSettings";
import PSCaptchaRecaptchaComponent from "@/Captcha/components/PSCaptchaRecaptchaComponent";
import PSFriendlyCaptchaComponent from "@/Captcha/components/PSFriendlyCaptchaComponent";

export default Vue.extend({
  name: "ps-captcha_routing",
  components: {
    "ps-captcha-recaptcha": PSCaptchaRecaptchaComponent,
    "ps-captcha-friendly": PSFriendlyCaptchaComponent
  },

  data() {
    return {
      sharedCaptch: SharedCaptchaSettings,
      isRecapcha: false,
      isFrienly: false,
      isLoaded: false
    };
  },
  methods: {
    reset() {
      if (this.isRecapcha) {
        this.$refs.recaptcha.reset();
      }
      if (this.isFrienly) {
        this.$refs.friendlyCap.reset();
      }
    },
    onSolution(solution) {
      this.val = solution;
    }
  },
  computed: {
    val: {
      // getter
      get: function() {
        return this.value;
      },
      // setter
      set: function(newVal) {
        this.$emit("input", newVal);
      }
    }
  },
  mounted() {
    PSCaptchaRoutingService.getSharedCaptcha().then(data => {
      this.sharedCaptch = data;
      if (
        this.sharedCaptch.captchaProvider === CaptchaProviderSettings.Google
      ) {
        this.isRecapcha = true;
      } else if (
        this.sharedCaptch.captchaProvider === CaptchaProviderSettings.Friendly
      ) {
        this.isFrienly = true;
      }
      this.isLoaded = true;
    });
  }
});
</script>
